import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/** A page's title row: h1, an optional lead line and actions aligned to the right. */
export function PageHeader(props: {
  title: ReactNode;
  lead?: ReactNode;
  actions?: ReactNode;
  before?: ReactNode;
  className?: string;
}) {
  return (
    <header className={cn("flex flex-col gap-1.5", props.className)}>
      {props.before}
      <div className="flex flex-wrap items-start justify-between gap-x-6 gap-y-3">
        <div className="flex min-w-0 flex-col gap-1">
          <h1 className="text-xl font-semibold tracking-tight text-balance text-fg">
            {props.title}
          </h1>
          {props.lead ? (
            <div className="max-w-prose text-sm leading-relaxed text-fg-secondary">
              {props.lead}
            </div>
          ) : null}
        </div>
        {props.actions ? (
          <div className="flex flex-wrap items-center gap-2">{props.actions}</div>
        ) : null}
      </div>
    </header>
  );
}

/** A section heading with optional trailing actions. */
export function SectionHeader(props: { id?: string; title: ReactNode; actions?: ReactNode }) {
  return (
    <div className="flex min-h-8 flex-wrap items-center justify-between gap-2">
      <h2 id={props.id} className="text-sm font-semibold text-fg">
        {props.title}
      </h2>
      {props.actions ? <div className="flex items-center gap-2">{props.actions}</div> : null}
    </div>
  );
}
